import serviceAxios from "../request.js";

export const create = (data) => {
    return serviceAxios({
      url: "/folder/create",
      method: "post",
      data,
    });
  };

//获取当前用户文件夹列表
export const allFolder = (data) => {
  return serviceAxios({
    url: "/folder/allFolder",
    method: "post",
    data,
  });
};
//重命名文件夹
export const update = (data) => {
    return serviceAxios({
      url: "/folder/update",
      method: "post",
      data,
    });
  };
  //删除文件夹
  export const folderDetete = (data) => {
    return serviceAxios({
      url: "/folder/delete",
      method: "post",
      data,
    });
  };

  
//批量或者单独把活动移动到文件夹
  export const creFolderActivityByAcid = (data) => {
    return serviceAxios({
      url: "/folder/creFolderActivityByAcid",
      method: "post",
      data,
    });
  };
//批量删除活动
  export const delTooActivity = (data) => {
    return serviceAxios({
      url: "/mine/delTooActivity",
      method: "post",
      data,
    });
  };
//获取文件夹下活动
  export const folderActivityByID = (data) => {
    return serviceAxios({
      url: "/folder/folderActivityByID",
      method: "post",
      data,
    });
  };
//批量或者单独把活动移出文件夹
  export const delFolderActivityByAcid = (data) => {
    return serviceAxios({
      url: "/folder/delFolderActivityByAcid",
      method: "post",
      data,
    });
  };
